import { supabase } from '../../../supabaseClient';
import { EventRepo } from './repositories/EventRepo';
import { PerformanceRepo } from './repositories/PerformanceRepo';
import { RecoveryRepo } from './repositories/RecoveryRepo';
import { ProgramRepo } from './repositories/ProgramRepo';

/**
 * DATABASE SERVICE (Orchestrator Proxy)
 * 100% Backward compatible with the original monolithic DB service.
 * Delegates all IO logic to domain-specific repositories.
 */
export const DB = {
    // Domain: Auth (Kept central for now)
    async getUser() {
        return await supabase.auth.getUser();
    },

    // Domain: Events (Delegated to EventRepo)
    ...EventRepo,

    // Domain: Performance (Delegated to PerformanceRepo)
    ...PerformanceRepo,

    // Domain: Recovery (Delegated to RecoveryRepo)
    ...RecoveryRepo,

    // Domain: Programs (Delegated to ProgramRepo)
    ...ProgramRepo
};
